module.exports = __webpack_public_path__ + "static/img/goal-13.5d5f7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/goal-13.png
// module id = 8Wo4
// module chunks = 2